import { render } from "./PermissionNew.vue?vue&type=template&id=0581cd86&scoped=true"
import script from "./PermissionNew.vue?vue&type=script&lang=js"
export * from "./PermissionNew.vue?vue&type=script&lang=js"

import "./PermissionNew.vue?vue&type=style&index=0&id=0581cd86&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/duanju-overseas_admin_vue_live/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0581cd86"]])

export default __exports__